export enum PriceTypeEnum {
  ALL = 'ALL',
  CODE_REDEMPTION = 'code_redemption',
  CREDITS = 'credits',
  SIMPLE = 'simple',
  CHARITY = 'charity'
}
